export default __webpack_public_path__ + "static/media/content-img.33d36f9f.webp";